import { render } from "./GeorgeKaye.vue?vue&type=template&id=14a3f7da&ts=true"
import script from "./GeorgeKaye.vue?vue&type=script&lang=ts"
export * from "./GeorgeKaye.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__